import { styled } from 'styled-system/jsx'

const Section = styled('section', {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '20px 22px',
    boxShadow: '0 12px 32px -22px rgba(128, 84, 255, 0.18)',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const HeaderRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
  },
})

const Title = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.2px',
  },
})

const Stamp = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
  },
})

const Grid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    gap: '12px',
  },
})

const Tile = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '14px',
    borderRadius: 'md',
    border: '1.5px solid',
    borderColor: '#F0EDFA',
    backgroundColor: 'quickpass.surfaceCool',
    transition:
      'transform {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}',
  },
  variants: {
    isUnlocked: {
      true: {
        borderColor: 'quickpass.primarySoft',
        backgroundColor: '#FFFFFF',
        _hover: {
          transform: 'translateY(-1px)',
          borderColor: 'quickpass.primary',
        },
      },
      false: {
        opacity: '0.55',
      },
    },
  },
})

const TileGlyph = styled('span', {
  base: {
    fontSize: '24px',
    lineHeight: '1',
  },
})

const TileTitle = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const TileHint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.4',
  },
})

const TileStatus = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    marginTop: '4px',
  },
  variants: {
    isUnlocked: {
      true: { color: 'quickpass.primary' },
      false: { color: 'quickpass.inkSoft' },
    },
  },
})

export {
  Section,
  HeaderRow,
  Title,
  Stamp,
  Grid,
  Tile,
  TileGlyph,
  TileTitle,
  TileHint,
  TileStatus,
}
